import { render, staticRenderFns } from "./_enrolmentId.vue?vue&type=template&id=6bf5ffb4&"
import script from "./_enrolmentId.vue?vue&type=script&lang=js&"
export * from "./_enrolmentId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports